import { VaultBrowser } from '../components/tools/VaultBrowser'

export default function VaultPage() {
  return (
    <main className="flex-1 p-6 overflow-y-auto">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Code Vault</h1>
        <VaultBrowser />
      </div>
    </main>
  )
}
